import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';


const NavMenu = () => {

  return (
    <>
      {/* TOP BAR */}
      <div className="topbar">
        <div className="container d-flex justify-content-between align-items-center flex-wrap gap-1">
          <div>
            <i className="fa fa-phone me-1"></i> +91 96672 33072
            <span className="sep">|</span>
            <i className="fa fa-envelope me-1"></i>
            <a href="#">oxford_express@yahoo.co.in</a>
            <span className="sep">|</span>
            <a href="#">info@oxfordexp.com</a>
          </div>
          <div>
            <i className="fa fa-clock me-1"></i> Mon–Sat: 9:00 AM – 7:00 PM
          </div>
        </div>
      </div>

      {/* NAVBAR */}
      <nav className="main-nav navbar navbar-expand-lg">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center gap-3" href="#">
              <img src="images/logo.png" alt="Oxford Express" />
          </a>

          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse justify-content-end" id="mainNav">
            <ul className="navbar-nav align-items-center gap-2">
              <li className="nav-item">
                <NavLink className="nav-link" onClick={() => window.scrollTo(0, 0)} to="/">Home</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={() => window.scrollTo(0, 0)} to="/about-us">About Us</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={() => window.scrollTo(0, 0)} to="/services">Services</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={() => window.scrollTo(0, 0)} to="/rate-and-texes">Rate & Taxes</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={() => window.scrollTo(0, 0)} to="/contact-us">Contact Us</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={() => window.scrollTo(0, 0)} to="/enquiry">Enquiry</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={() => window.scrollTo(0, 0)} to="/faqs">FAQ's</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>

    </>
  );
}

export default NavMenu